import { sortByKey } from "@notemeal/utils-sort";
import { PreviewMealPlanFragment } from "../../../types";

export const getMostRecentlyUpdatedMealPlan = (mealPlans: readonly PreviewMealPlanFragment[]): PreviewMealPlanFragment | null => {
  if (mealPlans.length === 0) {
    return null;
  }

  const sortedMealPlans = sortByKey(
    mealPlans.map(mp => ({
      ...mp,
      updatedAtDt: new Date(mp.updatedAt).getTime(),
    })),
    "updatedAtDt"
  );

  return sortedMealPlans[sortedMealPlans.length - 1];
};
